import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../components/Common/BreadCrumb";
import { SkeletonTheme } from "react-loading-skeleton";
import UsersList from "./UsersList";
import { useTranslation } from "react-i18next";

const Users = () => {
  const { t } = useTranslation();
  document.title = t("common.pageTitle", { page: t("users.pageTitle") });

  return (
    <>
      <SkeletonTheme baseColor="#F0F4F6" highlightColor="#e9ebec">
        <div className="page-content">
          <Container fluid>
            <BreadCrumb title={t("users.heading")} hideCrumbs={true} />
            <UsersList />
          </Container>
        </div>
      </SkeletonTheme>
    </>
  );
};

export default Users;
